{
  "el": {
    "select": {
      "actions": {
        "clear": "Εκκαθάριση",
        "filterProject": "Φιλτράρισμα ανά έργο",
        "filterUnit": "Φιλτράρισμα ανά ακίνητο",
        "noResults": "Κανένα αποτέλεσμα",
        "noResultsFor": "Κανένα αποτέλεσμα για {search}",
        "reset": "Επαναφορά",
        "selectCategory": "Επιλογή κατηγορίας",
        "selectUnit": "Επιλογή ακινήτου",
        "setToday": "Σήμερα",
        "startTyping": "Ξεκίνα να πληκτρολογείς για αναζήτηση"
      },
      "groups": {
        "customers": "Πελάτες",
        "employees": "Μέλη ομάδας"
      },
      "labels": {
        "allUnits": "Όλα τα ακίνητα",
        "contact": "Επαφή",
        "without": "Χωρίς",
        "withoutContact": "Χωρίς επαφή"
      },
      "placeholders": {
        "contact": "Αναζήτησε άτομο ή διάλεξε «χωρίς»..."
      }
    }
  }
}
